import { useMemo } from "react";
import type { Dashboard } from "@/shared/api/types";
import {
  mapDashboardsToCards,
  mapStatsToProducts,
  mapApiToDashboardStucks,
} from "../utils/mappers";

export function useDashboardData(dashboards: Dashboard[]) {
  const cards = useMemo(() => mapDashboardsToCards(dashboards), [dashboards]);

  const products = useMemo(() => {
    if (!dashboards.length) return [];
    const latestDashboard = dashboards[0];
    return mapStatsToProducts(latestDashboard.stats || []);
  }, [dashboards]);

  const stucks = useMemo(() => {
    const stuckLists = dashboards.flatMap((d) => d.imts ?? []);
    return mapApiToDashboardStucks(stuckLists);
  }, [dashboards]);

  return { cards, products, stucks };
}
